import React from "react";

import { priceBYN } from "../../../utils/formatHelpers";


export const BentoPriceInfo = ({productType}) => {
    return (
        <li className="main-goods-types__list-item">
            <div className="main-goods__price-box">
                <strong className="main-goods__price">{priceBYN(productType.price)}</strong>
            </div>
        </li>
    )
};
